import { clone, path } from "ramda";
import { FC } from "react";
import { useListContext } from "react-admin";

import { Query } from "../../types/firebase.types";
import { GenericObject } from "../../types/generic.types";
import BaseSearch from "./BaseSearch";
import { getSearchResults } from "./utils";

const SearchWithQuery: FC<AuctionSearchProps> = ({ query, source, label, searchKey, filterBy }) => {
  const context = useListContext();

  const handleSelect = (selected: GenericObject) => {
    context.setFilters(
      {
        ...context.filterValues,
        [source]: path((filterBy ?? source).split("."), selected) as any,
      },
      context.displayedFilters
    );
  };

  const handleCloseSearch = () => {
    const filterValues = clone(context.filterValues);
    const displayedFilters = clone(context.displayedFilters);
    delete filterValues[source];
    delete displayedFilters[source];
    context.setFilters(filterValues, displayedFilters);
  };

  return (
    <BaseSearch
      source={searchKey ?? source}
      label={label}
      query={query}
      onSelect={handleSelect}
      onClose={handleCloseSearch}
      getData={getSearchResults}
    />
  );
};

interface AuctionSearchProps {
  query: Query;
  label: string;
  source: string;
  searchKey?: string;
  filterBy?: string;
  className?: string;
}

export default SearchWithQuery;
